/* eslint-disable */
<template>
</template>

<script>
  export default {
    name: 'CSPReport',
    data () {
      return {
        user_email: '',
        user_name: '',
        options:'',
        frontendUrl: '',
        frontEndUrlToUse: ''
        }
      },
      created() {
        this.postCSP();
      },
      mounted: function () {
        this.postCSP();
        //this.loginUser();
      },
    methods: {
      getCookie(cname) {
        let self = this;
        let name = cname + "=";
        let ca = document.cookie.split(';');
        for (let i = 0; i < ca.length; i++) {
          let c = ca[i];
          while (c.charAt(0) == ' ') {
            c = c.substring(1);
          }
          if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
          }
        }
        return "";
        },

        postCSP() {
          let self = this;
          console.log("postCSP");
          const csrftoken = self.getCookie("token");//document.cookie.match(/csrftoken=([^;]+)/)[1];
          this.$axios.defaults.headers.common['X-CSRFToken'] = csrftoken;
          let requestData = {
            'log': "postCSP",
            'csrfmiddlewaretoken': csrftoken
          };
          //csrfmiddlewaretoken: "{{ csrf_token }}"
          this.$axios.post(self.$root.baseUrl + '/csp/report/', requestData, {
            Token: csrftoken
          })
            .then((res) => {
              res = res.data
              //console.log(res);
              if (res.status == 'ok') {
                var report = JSON.parse(res['report']);
                console.log(report);
              } else {
                self.$message.error(res.description);
                //console.log(res);
              }
            })
            .catch(function (error) {
              if (error.response) {
                console.log(error);
              }
            }
          )
          return true;
        },

    }
  }
</script>



// WEBPACK FOOTER //
// src/components/CSPReport.vue